import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { useParameters } from '@web/utils/src';
import { useReatailersQueryQuery } from '@/pages/FarmerPages/FarmersHomePage/retailers.generated';

interface NavLinkProps {
  to: string;
  label: string;
  end?: boolean;
}

const activeClasses =
  'flex items-center h-full text-body1 font-bd text-primary-green navLinkShadow';
const inactiveClasses = 'flex items-center h-full text-body1';

const NavigationLink = ({ to, label, end }: NavLinkProps) => {
  const { t } = useTranslation();
  const [resolvedTo, setResolvedTo] = useState<string>(to);
  const { retailerId } = useParameters<{ retailerId: string }>();
  const [{ data }] = useReatailersQueryQuery({
    pause: !!retailerId,
  });

  useEffect(() => {
    let finalTo = to;
    if (to.includes(':retailerId')) {
      if (retailerId) {
        finalTo = to.replace(':retailerId', retailerId);
      } else if (data?.retailers?.[0]?.id) {
        finalTo = to.replace(':retailerId', data.retailers[0].id);
      }
    }
    setResolvedTo(finalTo);
  }, [to, retailerId, data]);

  return (
    <NavLink
      to={resolvedTo}
      end={end}
      className={({ isActive }) => (isActive ? activeClasses : inactiveClasses)}
    >
      {t(`navigation.${label}` as any)}
    </NavLink>
  );
};

export default NavigationLink;
